import React, { useState, useEffect, useRef } from 'react';
import * as Icons from '@seismic/icons';
import { useTranslation } from 'react-i18next';
import CommonDialog from './common/commonModal';
import { clearSessionTimer, resetSessionTimer, closeSession } from '../commonUtil/sessionUtil';
import { isMobile } from '../commonUtil/responsiveUtil';
import { isMobileDevice } from '../commonUtil/util';
import { KeyBoardAction } from '../commonUtil/constants';

function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        const id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [callback, delay]);
}

const SESSION_EXPIRING_COUNTDOWN = 30;

const getModalStyle = () => {
    let expiringDialogStyle = {
        overlay: {
            zIndex: 10003
        },
        content: {
            width: '568px',
            height: '279px',
            borderRadius: '4px'
        }
    };

    if (isMobile()) {
        const content = {
            width: '100%',
            height: '100%',
            borderRadius: '0'
        };

        expiringDialogStyle = {
            ...expiringDialogStyle,
            content
        };
    }

    return expiringDialogStyle;
};

const SessionExpiringModal = (props) => {
    const { t } = useTranslation();
    const { afterSessionEnd, isOpen, setIsOpen } = props;
    const [count, setCount] = useState(-1);

    const continueSession = () => {
        setCount(-1);
        resetSessionTimer();
        setIsOpen(false);
    };

    const endSession = () => {
        setIsOpen(false);
        clearSessionTimer();
        afterSessionEnd();
        closeSession();
    };

    // eslint-disable-next-line no-unused-vars
    const openModal = () => {
        setIsOpen(true);
    };

    useInterval(() => {
        if (count > 1) {
            setCount(count - 1);
        } else if (count >= 0) {
            endSession();
        }
    }, 1000);

    const afterOpenModal = () => {
        if (count !== SESSION_EXPIRING_COUNTDOWN) {
            setCount(SESSION_EXPIRING_COUNTDOWN);
        }
    };

    const onCloseKeyDown = (e) => {
        if (e.keyCode === KeyBoardAction.enter) {
            continueSession();
        }
    };

    return (
        <CommonDialog
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            customStyles={getModalStyle()}
            shouldCloseOnOverlayClick={false}
            showCloseIcon={false}
            afterOpenModal={afterOpenModal}
            className={`${isMobileDevice.any() ? 'engagement-viewer-mobile-device' : ''} seismic-session-expiring-dialog`}>
            <div onClick={continueSession}
                className="common-close-icon"
                onKeyDown={onCloseKeyDown}
                tabIndex="0"
                role="button"
                aria-label="close modal">
                <Icons.CloseIcon />
            </div>
            <div className="seismic-session-expiring-dialog-content">
                <div className="seismic-session-expiring-dialog-title">{t('LIVE_SEND_VIEWER_SESSION_TIMEOUT')}</div>
                <div className="seismic-session-expiring-dialog-expiring-desc">{t('LIVE_SEND_VIEWER_SESSION_TIMEOUT_MESSAGE')}</div>
                <div className="seismic-session-expiring-dialog-expiring-seconds">
                    {count} {count > 1 ? t('LIVE_SEND_VIEWER_TIMROUT_SECONDS') : t('LIVE_SEND_VIEWER_TIMROUT_SECOND') }
                </div>
                <button className="enagement-buyer-btn btn-active btn-continue-session"
                    style={{ backgroundColor: props.brandingHilightColor }}
                    onClick={continueSession}>
                    {t('LIVE_SEND_VIEWER_CONTINUE_SESSION')}
                </button>
            </div>
        </CommonDialog>
    );
};

export default SessionExpiringModal;
